import { useGetPtCardInfo, useSuspensePtCardInfo } from '../model/query';
import { MAIN_DATA_SESSION_KEY } from '../consts';

export const WithSuspense = ({ hspId, mpiKey }) => {
  const {
    data: {
      data: { commonProcessYn },
    },
  } = useSuspensePtCardInfo({ hspId });

  const { data, isSuccess } = useGetPtCardInfo({ hspId, mpiKey }, commonProcessYn);

  if (isSuccess) {
    const { barcodeValue, ptNo, barcodeType, barcodeDefaultType, hspLogoImageUrl } = data.data;
    sessionStorage.setItem(
      MAIN_DATA_SESSION_KEY,
      JSON.stringify({
        hspId,
        barcodeValue,
        ptNo,
        barcodeType,
        barcodeDefaultType,
        hspLogoImageUrl,
      }),
    );
    window.location.replace(window.location.pathname);
  }
};
